import { render, staticRenderFns } from "./ResultadosLeads.vue?vue&type=template&id=997301f2"
import script from "./ResultadosLeads.vue?vue&type=script&lang=js"
export * from "./ResultadosLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports